import { useBrand } from '../../lib/brand-context.js';
import { displayName, initials, roleLabel } from './person.js';

/**
 * Spec 247 — Kridt's Person block (`.hub-person` inside `.hub-shell__me`):
 * a neutral disc, the display name, the role. Two lines.
 *
 * Replaces a 125px block that showed the account's email twice over four lines
 * beside an orange avatar. The disc here is not a button: the account menu
 * opens from the same disc at the end of the bar, which is always in view —
 * the sidebar is a drawer on a phone.
 */
export function PersonBlock() {
  const { user, loading } = useBrand();

  if (loading) {
    return (
      <div className="hub-person" aria-busy="true" data-testid="person-block">
        <span className="hub-avatar" aria-hidden="true" />
      </div>
    );
  }

  // Signed out, the shell is not shown at all — the sign-in sheet is. This is
  // the brief moment before that redirect lands.
  if (!user) return null;

  const name = displayName(user);
  return (
    <div className="hub-person" data-testid="person-block">
      <span className="hub-avatar" aria-hidden="true">{initials(name)}</span>
      <span className="hub-person__text">
        <span className="hub-person__name" data-testid="person-name">{name}</span>
        <span className="hub-person__role" data-testid="person-role">{roleLabel(user)}</span>
      </span>
    </div>
  );
}
